
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(
        private meta: Meta,
        @Inject(DOCUMENT) private document: HTMLDocument
    ) { }

    setMetaTags(title: string, description: string, route: string) {
        try {
            // console.log('title', title)
            // console.log('description', description)
            // console.log('route', route)

            this.meta.updateTag({ name: 'title', title })
            this.meta.updateTag({ name: 'description', description })

            this.meta.updateTag({ property: 'og:title', content: title })
            this.meta.updateTag({ property: 'og:description', content: description })
            this.meta.updateTag({ property: 'og:type', content: 'website' })
            this.meta.updateTag({ property: 'og:url', content: `${route}` })
        } catch (err) {
            throw err
        }
    }

    initBaseTags() {
        try {
            const title = this.document.URL.includes('tennis') ? 'TennisONE News' : 'GolfONE News'
            const description = this.document.URL.includes('tennis') ? 'Up to the minute tennis news' : 'Up to the minute golf news'

            this.meta.updateTag({ name: 'title', title })
            this.meta.updateTag({ name: 'description', description })

            this.meta.updateTag({ property: 'og:image', content: this.document.URL.includes('tennis') ? 'T1-512x512.png' : 'G1-512x512.png' })
            this.meta.updateTag({ property: 'og:image:alt', content: this.document.URL.includes('tennis') ? 'TennisONE Branded Logo' : 'GolfONE Branded Logo' })
        } catch (err) {
            throw err
        }
    }

    setMetaFavIcon() {
        try {
            let link: HTMLLinkElement = this.document.querySelector('link[rel="icon"]') || this.document.createElement('link')
            link.type = 'image/x-ico'
            link.rel = 'icon'
            link.href = this.document.URL.includes('tennis') ? 'T1-favicon.ico' : 'G1-favicon.ico'
            this.document.getElementsByTagName('head')[0].appendChild(link)
        } catch (err) {
            throw err
        }
    }
}
